import { render, staticRenderFns } from "./Vendorsignup.vue?vue&type=template&id=82d0c092&"
import script from "./Vendorsignup.vue?vue&type=script&lang=js&"
export * from "./Vendorsignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports